import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IntegrationType, Recipe } from '@pdqdev/pdq-shared/dist/entities';

@Component({
  selector: 'all-recipes',
  templateUrl: './all-recipes.component.html',
  styleUrls: ['./all-recipes.component.scss'],
  standalone: false,
})
export class AllRecipesComponent implements OnInit {
  @Input() recipes: Recipe[] = [];
  @Input() integrationType: IntegrationType;
  @Output() onTryTemplateClick = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
